"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataContainer = void 0;
var lodash_1 = __importDefault(require("lodash"));
var DataContainer = exports.DataContainer = (function () {
    function DataContainer() {
    }
    Object.defineProperty(DataContainer, "config", {
        get: function () {
            return DataContainer._config;
        },
        set: function (value) {
            DataContainer._config = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DataContainer, "measuringData", {
        get: function () {
            return DataContainer._measuringData;
        },
        set: function (value) {
            DataContainer._measuringData = value;
        },
        enumerable: false,
        configurable: true
    });
    DataContainer.getDataSetById = function (datasetId) {
        if (DataContainer._measuringData[datasetId]) {
            return DataContainer._measuringData[datasetId];
        }
        return {};
    };
    DataContainer.setDataSetById = function (datasetId, value) {
        DataContainer._measuringData[datasetId] = value;
    };
    DataContainer.getItemEnable = function (dataReferrer) {
        var displayFlagKey = dataReferrer.displayFlag;
        var dataId = dataReferrer.targetId;
        var enable = true;
        var targetDataConfig = lodash_1.default.find(DataContainer.config.dataset, function (o) { return o.id === dataId; });
        if (displayFlagKey && targetDataConfig) {
            enable = targetDataConfig[displayFlagKey];
        }
        return enable;
    };
    DataContainer._measuringData = {};
    DataContainer.isGraphApiResult = function (value) {
        return 'chart' in value;
    };
    return DataContainer;
}());
